export default defineNuxtRouteMiddleware((to, from) => {
    if (!to.matched.length) {
        return navigateTo('/login');
    }
    if (import.meta.server) 
        return;
    const nuxtApp = useNuxtApp()
    if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) 
        return;
    const { loggedIn } = useUserSession();
    let legalRoute = useRuntimeConfig().public.whiteList.findIndex((e) => to.path.startsWith(e)) > -1;
    if (!loggedIn.value && !legalRoute) {
        return navigateTo('/login');
    }
})